export default {"src":"/_next/static/media/3.824b697d.svg","height":170,"width":305,"blurWidth":0,"blurHeight":0};